import Vue from 'vue';
import VueI18n from 'vue-i18n';
import esLocale from './es';
import { UtilsString } from '@/utils/utils-string';
import esmenu from './esmenu';

Vue.use(VueI18n);

const messages = {
  es:  UtilsString.mergeclasses(esLocale,esmenu)
};

const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages,
});

export default i18n;
